import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { Lifecycle } from "server/models"
import {
    StoreType,
    LangType,
    ImportLifecycle,
    setLifecycleImportId,
    setLifecycleReloadImported,
} from "client/store"
import {
    Button,
    SpinnerIcon,
    UserIcon,
    TableColumn,
} from "client/components"

const Columns = (
    imported: number[],
    importFrom: "library" | "account",
    lifecycleNumber: number,
    maxLifecycleNumber: number,
) => {
    const importLifecycleId = useSelector((state: StoreType) => state.lifecycle.importLifecycleId)
    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const accountList = useSelector((state: StoreType) => state.account.accountList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const importFromLibrary = importFrom === "library"

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            cellMaxWidth: "300px",
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
        },
        {
            field: "type",
            header: lang.type,
            cellMinWidth: "150px",
            formatter: (lifecycle: Lifecycle) => lang[lifecycle.type as keyof LangType],
        },
        {
            field: "owner",
            header: lang.owner,
            cellMinWidth: "150px",
            formatter: (lifecycle: Lifecycle) => {
                const account = accountList[lifecycle.ownerAccount]
                const user = userList[lifecycle.creator]

                return lifecycle.ownerAccount === userData.accountId
                    ? <UserIcon user={user} size="sm" />
                    : account.name
            },
        },
    ]

    columns.push({
        field: "import",
        cellWidth: "100px",
        cellMinWidth: "100px",
        centerAlign: true,
        formatter: (lifecycle: Lifecycle) => {
            const allowedToImport = importFromLibrary
                ? lifecycleNumber < maxLifecycleNumber || maxLifecycleNumber === null
                : true

            return (
                <Button
                    variant="success"
                    disabled={!allowedToImport || imported.includes(lifecycle.id)}
                    onClick={() => {
                        if (importLifecycleId !== null) return

                        dispatch(setLifecycleImportId(lifecycle.id))
                        let promise: Promise<any>
                        if (importFromLibrary && project.id) {
                            promise = ImportLifecycle(userData.accountId, null, lifecycle).then((newLifecycle) => (
                                ImportLifecycle(userData.accountId, project.id, newLifecycle)
                            ))
                        } else {
                            promise = ImportLifecycle(userData.accountId, project.id, lifecycle)
                        }

                        promise.then(() => {
                            dispatch(setLifecycleImportId(null))

                            dispatch(setLifecycleReloadImported(false))
                            setTimeout(() => {
                                dispatch(setLifecycleReloadImported(true))
                            }, 0)
                        })
                    }}
                >
                    { importLifecycleId === lifecycle.id ? <SpinnerIcon /> : lang.add }
                </Button>
            )
        },
    })

    return columns
}
export default Columns
